import React from "react"
import { Navigate } from "react-router-dom"
import CreativeInsightsDashboard from "../pages/Insights/CreativeInsightsDashboard.jsx"
import CategoryAllPage from "../pages/CategoryAllPage.jsx"

// Dashboard
import Dashboard from "../pages/Dashboard/OptimizedDashboard"

//Pages
import PagesStarter from "../pages/Utility/pages-starter"
import PagesMaintenance from "../pages/Utility/pages-maintenance"
import PagesComingsoon from "../pages/Utility/pages-comingsoon"
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"
import MarketResearch from "../pages/MarketResearch/marketResearch"
import CategoryAnalysis from "../pages/CategoryAnalysis/CategoryAnalysis"
import PublisherAnalysis from "../pages/MarketResearch/PublisherAnalysis"
import CategorySuggestions from "../pages/CategorySuggestions.jsx"
import GameDashboard from "../pages/IndividualApp/gameDashboard"
import AppsFromPublisher from "../pages/PublisherAnalysis/PublisherAnalysis"
import PublisherSocials from "../pages/PublisherAnalysis/PublisherSocials"
import KeywordTracking from "../pages/KeywordTracking/keywordTracking"
import KeywordTrackingLandingPage from "../pages/KeywordTracking/keywordTrackingLandingPage"
import CategoryTrackingLandingPage from "../pages/CategoryTracking/categoryTrackingLandingPage"
import CategoryTracking from "../pages/CategoryTracking/categoryTracking"
import UserProfile from "../pages/UserProfile/userProfile"
import ProfileSettings from "../pages/UserProfile/ProfileSettings"
import Plans from "../pages/UserProfile/userPlan"
import PaymentMethod from "../pages/UserProfile/userPayment"
import ResetPassword from "../pages/Authentication/ResetPassword"
import VerifyUser from "../pages/Authentication/VerifyUser"
import Topapps from "../pages/MetaInsight/TopApps"
import Popular from "../pages/MetaInsight/Popular"
import MostPopularPage from "../pages/MetaInsight/MostPopular"
import PreOrdersPage from "../pages/MetaInsight/PreOrders"
import TopRevenued from "../pages/CustomInsight/TopRevenued"
import CustomInsightsDashboard from "../pages/CustomInsight/CustomInsightsDashboard"
import ComingSoon from "../pages/coming soon/ComingSoon"
import TopAppScore from "../pages/CustomInsight/TopAppScore"
import TopKeywordCategory from "../pages/CustomInsight/TopKeywordCategory"
import TopRated from "../pages/CustomInsight/TopRated"
import TopDownloaded from "../pages/CustomInsight/TopDownloaded"
import TopReviewed from "../pages/CustomInsight/TopReviewed"
import TopGenres2025 from "../pages/CustomInsight/TopGenres2025"
import ChatBot from "../pages/ChatBot/ChatBot"
import AppTrackingv2 from "../pages/AppTracking/appTrackingv2"
import KeywordTrackingUIContainer from "../pages/NewKeywordTrackingUI/OptimizedKeywordTrackingUIContainer"
import KeywordDetails from "../pages/KeywordTracking/keywordDetails"
import CategoryDetails from "../pages/CategoryTracking/CategoryDetails"
import PaymentSuccess from "../pages/UserProfile/PaymentSuccess"
import PaymentCancel from "../pages/UserProfile/PaymentCancel"
import TrendingPages from "../pages/MetaInsight/Trending"
import NewReleasePage from "../pages/MetaInsight/newRelease"
import WeeklyInsightsDashboard from "../pages/MetaInsight/WeeklyInsightsDashboard"
import TopDiscounts from "../pages/MetaInsight/TopDiscounts"
import LandingPage from "../pages/LandingPage"
import BlogList from "../pages/Blog/BlogList"
import BlogDetail from "../pages/Blog/BlogDetail"
import BlogPreview from "../pages/Blog/BlogPreview"
import AboutUs from "../pages/AboutUs/AboutUs"
import FAQ from "../pages/FAQ/FAQ"
import Support from "../pages/Support/Support"
import KeywordSuggestions from "../pages/KeywordSuggestions/KeywordSuggestions"
import SocialMediaComparison from "../pages/SocialMediaComparison/SocialMediaComparison"
import UGCExplorer from "../pages/UGCExplorer/UGCExplorer"
import InfluencerExplorer from "../pages/InfluencerExplorer/InfluencerExplorer"
import InfluencerProfile from "../pages/InfluencerExplorer/InfluencerProfile"
import NewsletterUnsubscribe from "../pages/Newsletter/NewsletterUnsubscribe"
import PrivacyPolicy from "../pages/Legal/PrivacyPolicy"
import TermsOfService from "../pages/Legal/TermsOfService"
import ContactUs from "../pages/ContactUs/ContactUs"
import Feedback from "../pages/Feedback/Feedback"
import AppScanner from "../pages/AppScanner/AppScanner"
import Report from "../pages/Report/Report"
import PublicReport from "../pages/Report/PublicReport"
import SidequestPreRegister from "../pages/Sidequest/SidequestPreRegister"
import StoreValidator from "../pages/StoreValidator/StoreValidator"
import StoreValidatorPreview from "../pages/StoreValidator/StoreValidatorPreview"
const userRoutes = [
  { path: "/dashboard", component: <Dashboard />, auth: false },
  { path: "/contact-us", component: <ContactUs />, auth: true },
  { path: "/feedback", component: <Feedback />, auth: false },
  { path: "/sidequest/pre-register", component: <SidequestPreRegister />, auth: false },


  // Market Research & Analysis (clean URLs)
  { path: "/keyword-search", component: <MarketResearch /> },
  { path: "/category-analysis", component: <CategoryAnalysis /> },
  { path: "/publisher-analysis", component: <PublisherAnalysis /> },

  // App & Publisher Pages
  // Canonical path-based URL (SEO-friendly); the app-id also still lands here via redirect from the legacy ?item_id= form.
  { path: "/publisher-apps/:itemId", component: <AppsFromPublisher />, auth: false },
  { path: "/publisher-apps", component: <AppsFromPublisher />, auth: false },
  { path: "/publisher-socials", component: <PublisherSocials />, auth: false },

  // Tracking Pages (clean URLs)
  { path: "/app-tracking", component: <AppTrackingv2 /> },
  { path: "/keyword-analysis", component: <KeywordTrackingUIContainer /> },
  { path: "/keyword-tracking-old", component: <KeywordTracking /> },
  { path: "/keyword-tracking", component: <KeywordTrackingLandingPage /> },
  { path: "/keyword-suggestions", component: <KeywordSuggestions /> },
  { path: "/social-media-comparison", component: <SocialMediaComparison /> },
  { path: "/category-explorer", component: <CategorySuggestions /> },
  { path: "/ugc-explorer", component: <UGCExplorer /> },
  // Deep link from a website notification, e.g. "/ugc-explorer/youtube/6061406827268889"
  // - see the appId/platform parsing in UGCExplorer.jsx.
  { path: "/ugc-explorer/:platform/:appId", component: <UGCExplorer /> },
  { path: "/influencer-explorer", component: <InfluencerExplorer /> },
  { path: "/influencer-explorer/:platform/:username", component: <InfluencerProfile /> },
  { path: "/category-tracking", component: <CategoryTrackingLandingPage /> },
  // Category All Page (See All)
  { path: "/categories/:category", component: <CategoryAllPage /> },
  { path: "/keyword-tracking-detail", component: <KeywordTracking /> },
  { path: "/category-tracking-detail", component: <CategoryTracking /> },

  // Detail Pages (keeping query params for now)
  { path: "/xr/keyword", component: <KeywordDetails /> },
  { path: "/xr/keyword/:appName", component: <KeywordDetails /> },
  { path: "/xr/category", component: <CategoryDetails /> },
  { path: "/xr/category/:appName", component: <CategoryDetails /> },

  // Game Dashboard (Wildcard for app paths)
  { path: "/xr/*", component: <GameDashboard />, auth: false },

  // Meta Insights (public pages)
  { path: "/weekly-insights", component: <WeeklyInsightsDashboard /> },
  { path: "/trending", component: <TrendingPages />, auth: false },
  { path: "/new-releases", component: <NewReleasePage />, auth: false },
  { path: "/top-apps", component: <Topapps />, auth: false },
  { path: "/popular", component: <Popular />, auth: false },
  { path: "/most-popular", component: <MostPopularPage />, auth: false },
  { path: "/pre-orders", component: <PreOrdersPage />, auth: false },
  { path: "/top-discounts", component: <TopDiscounts />, auth: false },

  // Custom Insights
  { path: "/custom-insights", component: <CustomInsightsDashboard /> },
  { path: "/creative-insights", component: <CreativeInsightsDashboard /> },
  { path: "/top-revenued", component: <TopRevenued />, auth: false },
  { path: "/all-time-hits", component: <TopAppScore />, auth: false },
  { path: "/top-keywords-categories", component: <TopKeywordCategory />, auth: false },
  { path: "/top-rated", component: <TopRated />, auth: false },
  { path: "/top-downloaded", component: <TopDownloaded />, auth: false },
  { path: "/top-reviewed", component: <TopReviewed />, auth: false },
  { path: "/top-genres-2025", component: <TopGenres2025 />, auth: false },

  // Other
  { path: "/chatbot", component: <ChatBot /> },
  { path: "/coming-soon", component: <ComingSoon /> },
  { path: "/ai-cmo", component: <AppScanner />, auth: false },
  { path: "/ai-cmo/:genre/:slug", component: <AppScanner />, auth: false },
  { path: "/report", component: <Report />, auth: false },
  { path: "/report/:slug", component: <PublicReport />, auth: false },
  { path: "/store-validator", component: <StoreValidator />, auth: false },
  { path: "/store-validator/preview", component: <StoreValidatorPreview />, auth: false },

  // Blog
  { path: "/blog", component: <BlogList />, auth: false },
  { path: "/blog/:slug", component: <BlogDetail />, auth: false },
  { path: "/blog/preview/:slug", component: <BlogPreview />, auth: false },

  // Public Pages
  { path: "/about-us", component: <AboutUs />, auth: false },
  { path: "/faq", component: <FAQ />, auth: false },
  { path: "/support", component: <Support /> },
  { path: "/privacy", component: <PrivacyPolicy />, auth: false },
  { path: "/terms", component: <TermsOfService />, auth: false },
  { path: "/newsletter/unsubscribe", component: <NewsletterUnsubscribe />, auth: false },

  { path: "/payment-success", component: <PaymentSuccess /> },
  { path: "/payment-cancel", component: <PaymentCancel /> },

  // ========== BACKWARD COMPATIBILITY REDIRECTS ==========
  // Old URLs redirect to new clean URLs
  { path: "/keywordSearch", component: <Navigate to="/keyword-search" replace /> },
  { path: "/categoryanalysis", component: <Navigate to="/category-analysis" replace /> },
  { path: "/publisheranalysis", component: <Navigate to="/publisher-analysis" replace /> },
  { path: "/gamedashboard", component: <Navigate to="/xr/app" replace /> },
  { path: "/app-details", component: <Navigate to="/xr/app" replace /> }, // Redirect old app-details to analytics
  { path: "/apptracking", component: <Navigate to="/app-tracking" replace /> },
  { path: "/publisherapps", component: <Navigate to="/publisher-apps" replace /> },
  { path: "/keywordSearchNew", component: <Navigate to="/keyword-analysis" replace /> },
  { path: "/keywordtracking", component: <Navigate to="/keyword-tracking-old" replace /> },
  { path: "/keywordtrackinglandingpage", component: <Navigate to="/keyword-tracking" replace /> },
  { path: "/categorytrackinglandingpage", component: <Navigate to="/category-tracking" replace /> },
  { path: "/categorytracking", component: <Navigate to="/category-tracking-detail" replace /> },
  { path: "/market-research", component: <Navigate to="/keyword-search" replace /> },
  { path: "/category-analysis-old", component: <Navigate to="/category-analysis" replace /> },
  { path: "/publisher-analysis-old", component: <Navigate to="/publisher-analysis" replace /> },
  { path: "/keyworddetails", component: <Navigate to="/xr/keyword" replace /> },
  { path: "/keyword-details", component: <Navigate to="/xr/keyword" replace /> }, // Redirect old keyword-details
  { path: "/Categorydetails", component: <Navigate to="/xr/category" replace /> },
  { path: "/category-details", component: <Navigate to="/v/category" replace /> }, // Redirect old category-details
  { path: "/newRelease", component: <Navigate to="/new-releases" replace /> },
  { path: "/topapps", component: <Navigate to="/top-apps" replace /> },
  { path: "/mostpopular", component: <Navigate to="/most-popular" replace /> },
  { path: "/preorders", component: <Navigate to="/pre-orders" replace /> },
  { path: "/top-discounts", component: <Navigate to="/top-discounts" replace /> },
  { path: "/topgross", component: <Navigate to="/top-revenued" replace /> },
  { path: "/topimproved", component: <Navigate to="/all-time-hits" replace /> },
  { path: "/all_time_hits", component: <Navigate to="/all-time-hits" replace /> },
  { path: "/Top_Keywords_Categories", component: <Navigate to="/top-keywords-categories" replace /> },
  { path: "/toprated", component: <Navigate to="/top-rated" replace /> },
  { path: "/topdownloaded", component: <Navigate to="/top-downloaded" replace /> },
  { path: "/topreviewed", component: <Navigate to="/top-reviewed" replace /> },
  { path: "/comingsoon", component: <Navigate to="/coming-soon" replace /> },
  // ========== END REDIRECTS ==========

  //Utility
  { path: "/pages-starter", component: <PagesStarter /> },
  { path: "/profile", component: <UserProfile /> },
  { path: "/profile/settings", component: <ProfileSettings /> },
  { path: "/profile/plans", component: <Plans /> },
  { path: "/profile/payment", component: <PaymentMethod /> },
  { path: "/payment/success", component: <PaymentSuccess /> },
  { path: "/payment/cancel", component: <PaymentCancel /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "*", component: <Navigate to="/dashboard" /> },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/user/reset-password/:token", component: <ResetPassword /> },
  { path: "/user/verify/:token", component: <VerifyUser /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },

  // Landing Page (Root)
  { path: "/", component: <LandingPage /> },
]

export { userRoutes, authRoutes }